import { createBrowserRouter } from 'react-router-dom';
import AdminPanel from '../pages/AdminPanel';
import EmployeeLogin from '../pages/EmployeeLogin';
import StudentReports from '../pages/StudentReports';
import Invoice from '../pages/Invoice';
import AllStudents from '../pages/AllStudents';
import AllInvoice from '../pages/AllInvoice';

const router = createBrowserRouter([
    {
        path: "/employee-login", element: <EmployeeLogin />,
    },
    {
        path: "/",
        element: <AdminPanel />,
        children: [
            { path: "/", element: <StudentReports /> },
            { path: "/invoice", element: <AllInvoice/> },
            { path: "/all-students", element: <AllStudents /> },
        ]
    }
]);

export default router;
